import React, { useContext, useEffect, useState } from "react";
import CustomDropDownList from "../../../../components/CustomDropDown/CustomDropDownList";
import studylistContext from "../../../../context/studylist/StudylistContext";
import { t } from "i18next";
import { Icon, IconButton, PrimaryButton, Spinner, SpinnerSize, TextField } from "@fluentui/react";
import { assignProvider, assignProviderByAdmin, getClientProviders } from "../../../../service/StudyListService";
import loaderContext from "../../../../context/loader/LoaderContext";
import { BORDER, MODAL_TYPE, TOAST_TYPE, USERTYPES } from "../../../../constants/Constants";
import userContext from "../../../../context/users/UserContext";
import toastContext from "../../../../context/toast/ToastContext";
import Moment from "moment";

const MobileAssignmentFilter = (props) => {
  const { mobileAssignmentObject, setMobileAssignmentObject,setDataQueryState,dataQueryState } =
    useContext(studylistContext);
    const { showToastv2 } = useContext(toastContext);
    const { roles } = useContext(userContext);
    const { showModal, setShowModal } = useContext(loaderContext);

    let baseURL = window.location.origin + "/";
  const [showDropdownList, setDropdownList] = useState(true);
  const [reportingProviderDto, setReportingProviderDto] = useState({});
  const [textFieldFocus, setTextFieldFocus] = useState(false);

  const handleOnSelect = (value,key,index) => {
    let reportingProvider = {
        studyId: mobileAssignmentObject.data.row.original.id,
        clientId: mobileAssignmentObject.data.row.original.assignmentList[index].clientId,
        firmId: mobileAssignmentObject.data.row.original.assignmentList[index].firmId,
        providerId: key,
        assignedProviderId:
        mobileAssignmentObject.data.row.original.assignmentList[index].providerId,
        assignName: value
      };
      setReportingProviderDto(reportingProvider);
  }

  const handleUpdateRowForAssign = (assignUpdateDetails) => {
    console.log("---DataQueryState---",dataQueryState);
    var currentDate = Moment().format('DD-MMM-YY HH:mm');
    let newIndex = -1; 
    let newData = dataQueryState?.data?.rows.filter(
      (row, index) => {
        if (row.id == mobileAssignmentObject.data.row.original.id) {
          newIndex = index; 
          return true; 
        }
        return false;
      }
    );
    console.log("---Index---",newIndex);
      setDataQueryState(() => {
        const newValue = {
          ...dataQueryState
        };
        newValue.data.rows[newIndex].assignmentList[0].providerName = assignUpdateDetails.assignName;
        newValue.data.rows[newIndex].assignmentList[0].providerId = assignUpdateDetails.providerId;
        // newValue.data.rows[newIndex].assignmentList[assignUpdateDetails.assignIndex].assignmentDateDisplay = currentDate;
        return newValue;
      });
  
  }

  const callService = async() => {
            
       
            const body = {
              reportingProvider: reportingProviderDto,
              baseURL: baseURL,
            };
            console.log(body);
            //setLoaderRunning(true);
            //ref.current.continuousStart();
            // setIsLoadingAssignment(true);
            const response =
              roles[0] === USERTYPES.ADMIN
                ? await assignProviderByAdmin(body)
                : await assignProvider(body);
           console.log("--- Data assign ---",response);
           
            if (response.status === 200 && response.data.result === "SUCCESS") {
            //   setProviderId(assignedProviderId);
            handleClosePopup();
              if(roles[0] === USERTYPES.ADMIN){
                try{
                //   handleAutoUpdateForSelectAssignment(response?.data?.data?.assignmentList);
                }catch(e){
                  console.log("--- Error in creating new assignment row ----");
                }
              }
              handleUpdateRowForAssign(reportingProviderDto)
            setShowModal(() => {
                const newItem = { ...showModal };
                newItem.show = true;
                newItem.type = MODAL_TYPE.ALERT_MODAL;
                newItem.heading = "Alert";
                newItem.description = roles[0] === USERTYPES.ADMIN
                ? t("study-list.messages.assign-success")
                : t("study-list.messages.assign-success-to",{name:response.data.data});
                return newItem;
              });
            //   showToastv2(
            //     TOAST_TYPE.SUCCESS,
            //     roles[0] === USERTYPES.ADMIN
            //       ? t("study-list.messages.assign-success")
            //       : t("study-list.messages.assign-success-to",{name:response.data.data})
            //   );
            //   props.batchAssign(reportingProviderDto, false);
            } else {
              //ref.current.complete();
            //   setIsLoadingAssignment(false);
            setShowModal(() => {
                const newItem = { ...showModal };
                newItem.show = true;
                newItem.type = MODAL_TYPE.ALERT_MODAL;
                newItem.heading = "Alert";
                newItem.description = roles[0] === USERTYPES.ADMIN
                  ? t("study-list.messages.assign-error")
                  : t("study-list.messages.assign-error-to",{name:response.data.data})
                return newItem;
              });
            //   showToastv2(
            //     TOAST_TYPE.ERROR,
            //     roles[0] === USERTYPES.ADMIN
            //       ? t("study-list.messages.assign-error")
            //       : t("study-list.messages.assign-error-to",{name:response.data.data})
            //   );
            }

      

  };

  useEffect(() => {
    console.log("--- Running this ---", mobileAssignmentObject);
  }, []);

  const handleClosePopup = () => {
    setMobileAssignmentObject(() => {
      const newItem = { ...mobileAssignmentObject };
      newItem.showProviderFilter = false;
      newItem.index = 0;
      newItem.data = null;
      return newItem;
    });
  };

  useEffect(() => {
    const onBeforeUnload = (event) => {
      // Prevent the user from leaving the page
      console.log("---Before-Unloading Running---",event);
      if(Object.keys(mobileAssignmentObject)?.length > 0){
        handleClosePopup();
        event.returnValue = '';
        event.preventDefault();
      }

     
    };
    console.log("---Event beforeunload Added---")
    window.addEventListener('beforeunload', onBeforeUnload);
  
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, []);

  return (
    <>
      <div className="popup-content"
      style={{ height: textFieldFocus ? "calc(100vh - 100px)" : "60vh" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            flexDirection: "column",
            alignItems: "center",
            height: "13%",
            borderBottom: "1px solid #3D3D3D",
            padding: "10px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <span className="study-list-mobile-filter-txt">
              {t("heading.assign-provider")}
            </span>
            <div className="study-list-mobile-close-icon-div">
              <IconButton
                //style={{ color: "white" }}
                //style={{color : "var(--navbar-header-popup-color-txt)"}}
                style={{color : "var(--mobile-color-txt)"}}
                iconProps={{ iconName: "Cancel" }}
                ariaLabel="Close popup filter mobile"
                onClick={() => {
                  handleClosePopup();
                }}
              />
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection:"column",
            width: "100%",
            height:"75%",
            boxSizing:"border-box",
            padding: "0px 20px",
            marginTop:"10px"
          }}
        >
          <ProviderMobileList
            handleOnSelect={handleOnSelect}
            data={mobileAssignmentObject.data}
            setTextFieldFocus={setTextFieldFocus}
            reportingProviderDto={reportingProviderDto}
            setReportingProviderDto={setReportingProviderDto}
          />
        </div>
        <div className="study-list-mobile-filter-button-section">
              <PrimaryButton
                text={t("button.assign")}
                onClick={() => {
                    callService()
                }}
                style={{width:"100%"}}
                className={"common-default-active-button"}
                />
              
            </div>
      </div>
    </>
  );
};

export default MobileAssignmentFilter;

const ProviderMobileList = (props) => {
  const {
    handleUpdateDataQueryStateProviderList,
    providerDdlList,
    setProviderDdlList,
  } = useContext(studylistContext);
  const { showModal, setShowModal } = useContext(loaderContext);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filterValue, setFilter] = useState("");
  const { roles } = useContext(userContext);
  const [clientProvidersList, setClientProvidersList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const data = props.data.row.original;

  let enterprise =
    process.env.REACT_APP_ENTERPRISE_PLATFORM == "true" ||
    process.env.REACT_APP_ENTERPRISE_PLATFORM == true
      ? true
      : false;

  const generateClientProviders = async () => {
    let radiologistList = [];
    const clientProvidersMapping = {
      clientId: props.data.row.original.assignmentList[0].clientId,
      firmId: props.data.row.original.assignmentList[0].firmId,
      studyId: props.data.row.original.id,
    };
    try {
      setLoading(true);
      const response = await getClientProviders(clientProvidersMapping);
      console.log(response);
      if (response.status === 200 && response.data.result === "SUCCESS") {
        if (
          (response.data.data.radiologists != null ||
            response.data.data.radiologists != undefined) &&
          response.data.data.radiologists.length > 0
        ) {
          response.data.data.radiologists.map((radiologist) => {
            let providerRadName =
              radiologist.firstName + " " + radiologist.lastName;
            let onPayroll =
              !enterprise && radiologist.onPayroll === true ? " *" : " ";
            radiologistList.push({
              key: "R" + radiologist.id,
              text: providerRadName + onPayroll,
              activeStatus: radiologist.activeStatus,
            });
          });
        }
        if (props.data.row.original.reportDoneStatus != 2) {
          if (
            (response.data.data.providers != null ||
              response.data.data.providers != undefined) &&
            response.data.data.providers.length > 0
          ) {
            response.data.data.providers.map((provider) => {
              radiologistList.push({
                key: "F" + provider.id,
                text: provider.name,
              });
            });
          }
        }
        if (radiologistList.length == 0) {
          radiologistList.push({
            key: "0",
            text: !enterprise
              ? "Providers not found."
              : "Radiologists not found.",
          });
        }
        setLoading(false);
        handleUpdateDataQueryStateProviderList(radiologistList, data.id);
        setClientProvidersList(radiologistList);
        setOriginalList(radiologistList);
      } else {
        setLoading(false);
        setShowModal(() => {
          const newItem = { ...showModal };
          newItem.show = true;
          newItem.type = MODAL_TYPE.ALERT_MODAL;
          newItem.heading = "Error";
          newItem.description = t("string-literals.error-msg");
          return newItem;
        });
      }
    } catch (e) {
      console.log("---Exception---", e);
      setLoading(false);
      setShowModal(() => {
        const newItem = { ...showModal };
        newItem.show = true;
        newItem.type = MODAL_TYPE.ALERT_MODAL;
        newItem.heading = "Error";
        newItem.description = t("string-literals.error-msg");
        return newItem;
      });
    }
  };

  useEffect(() => {
    setLoading(true);
    if (
      providerDdlList.hasOwnProperty(data.id) &&
      roles[0] != USERTYPES.ADMIN
    ) {
      setLoading(false);
      setClientProvidersList(providerDdlList[data.id]);
      setOriginalList(providerDdlList[data.id]);
    } else {
      generateClientProviders();
    }
  }, []);

  const handleFilterChange = (event, data) => {
    if (data != null && data != undefined) data = data.trim();
    const inputValue = data;
    setFilter(inputValue);

    // Filter the original list based on the filter value
    const filteredResults = originalList.filter((item) =>
      item.text.toLowerCase().includes(inputValue.toLowerCase())
    );

    // Set the filtered results to the state
    setClientProvidersList(filteredResults);
  };

  const customSpinnerStyle = {
    root: {
      height: "100px",
    },
    circle: {
      height: "20px",
      width: "20px",
      borderWidth: "3px",
    },
  };

  const getRadiologistStatusColor = (status) => {
    if (status == 0) {
      return "gray";
    } else if (status == 1) {
      return "red";
    } else if (status == 2) {
      return "green";
    }
  };

  const searchIcon = {
    iconName: "search",
    cursor: "pointer",
    style: { color: "rgba(172, 172, 172, 0.75)" },
  };

  const searchInputStyle = {
    root: {
      width: "100%",
    },
    field: {
      borderRadius: "7px",
    },
  };

  useEffect(() => {
    console.log("--reportingProviderDto--", props.reportingProviderDto);
  }, [props.reportingProviderDto]);

  const checkIfProviderSelected = () => {
    if(Object.keys(props.reportingProviderDto)?.length > 0){
      return false;
    }
    return true;
  }

  return (
    <>
      {!loading && (
        checkIfProviderSelected() ? <TextField
          label=""
          placeholder="Search..."
          styles={searchInputStyle}
          value={filterValue}
          onClick={(ev) => {
            ev.stopPropagation();
            console.log(ev);
          }}
          onChange={(ev, value) => {
            ev.stopPropagation();
            handleFilterChange(ev, value);
          }}
          onFocus={(e) => {props.setTextFieldFocus != undefined && props.setTextFieldFocus(true)}}
          onBlur={() => {props.setTextFieldFocus != undefined && props.setTextFieldFocus(false)}}
          iconProps={searchIcon}
          // autoFocus={true}
        />:
        <SelectedProviderBadge reportingProviderDto={props.reportingProviderDto} setReportingProviderDto={props.setReportingProviderDto}/>
      )}
      <div
        style={{
          alignItems:
            !loading && clientProvidersList.length != 0
              ? "flex-start"
              : "center",
        }}
        className="custom-drodown-list-container assign-dropdown-modal-scroll"
      >
        {loading ? (
          <Spinner size={SpinnerSize.small} styles={customSpinnerStyle} />
        ) : clientProvidersList.length > 0 ? (
          <>
            {clientProvidersList.map((ele, index) => {
              return (
                ele.key[0] == "R" && (
                  <div
                    onClick={(ev) => {
                      props.handleOnSelect(ele.text, ele.key, 0);
                    }}
                    key={index}
                    className="custom-dropdown-list-item"
                  >
                    {ele.key[0] == "R" && (
                      <div
                        className="active-circle"
                        style={{
                          background: getRadiologistStatusColor(
                            ele.activeStatus
                          ),
                        }}
                      ></div>
                    )}
                    {ele.key[0] == "R" && (
                      <span style={{ width:"fit-content",wordWrap: "break-word" }}>
                        {ele.text}
                      </span>
                    )}
                  </div>
                )
              );
            })}
            <div
              style={{ width: "100%", height: "2px", borderTop: BORDER.TAB }}
            ></div>
            {clientProvidersList.map((ele, index) => {
              return (
                ele.key[0] !== "R" && (
                  <div
                    onClick={() => {
                      props.handleOnSelect(ele.text, ele.key, 0);
                    }}
                    key={index}
                    className="custom-dropdown-list-item"
                  >
                    {ele.text}
                  </div>
                )
              );
            })}
          </>
        ) : (
          <div className="custom-dropdown-list-item">No record found</div>
        )}
      </div>
    </>
  );
};

const SelectedProviderBadge = ({reportingProviderDto,setReportingProviderDto}) => {
  return (
    <div
      className="study-list-badge-list-view"
      style={{
        cursor: "auto",
        marginBottom: "10px",
        width:"fit-content",
        background: "rgb(0, 120, 212)",
        lineHeight:"unset",
        height:"unset"
      }}
      //onClick={() => setShowFilterOptions(true)}
    >
      <span style={{whiteSpace:"unset"}} className="study-list-badge-text-list-view">{reportingProviderDto.assignName}</span>

      <Icon
        onClick={(event) => {
          event.stopPropagation();
          setReportingProviderDto({});
        }}
        style={{
          cursor: "pointer",
          // color: "white",
          lineHeight: "2",
          marginLeft: "5px",
        }}
        iconName="Cancel"
        className="ms-fontSize-10"
      ></Icon>
    </div>
  );
};